import React, { useState } from 'react';
import './settings.css';

const ManageAccount = () => {
  const [emailOptOut, setEmailOptOut] = useState(false);
  const [deactivateAccount, setDeactivateAccount] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('en');

  return (
    <div>
      <h2>Manage Your Preferences</h2>

      <div className="mp-box">
        <div className="mp-box-header">
          <h4>Email Opt Out</h4>
          <label className="switch">
            <input
              type="checkbox"
              checked={emailOptOut}
              onChange={() => setEmailOptOut(!emailOptOut)}
            />
            <span className="slider round"></span>
          </label>
        </div>
        <p>
          Opt out of receiving future emails from Torfacts. Our emails keep
          you posted on all the lucrative surveys available for you. Are you
          sure you want to stop them?
        </p>
      </div>

      <div className="mp-box">
        <div className="mp-box-header">
          <h4>Deactivate Account</h4>
          <label className="switch">
            <input
              type="checkbox"
              checked={deactivateAccount}
              onChange={() => setDeactivateAccount(!deactivateAccount)}
            />
            <span className="slider round"></span>
          </label>
        </div>
        <p>
          Deactivating your account will disable your profile from Torfacts.
        </p>
      </div>

      <div className="mp-box">
        <h4>Change Language</h4>
        <select
          value={selectedLanguage}
          onChange={(e) => setSelectedLanguage(e.target.value)}
          className="language-select"
        >
          <option value="en">English</option>
          <option value="hi">Hindi</option>
          <option value="es">Spanish</option>
          <option value="fr">French</option>
        </select>
        <p>
          Choose your preferred language to receive communication and view
          content accordingly.
        </p>
      </div>
    </div>
  );
};

export default ManageAccount;
